const STORAGE_PREFIX = 'dash.pureLlm.mutationPreview:';

function safeStorage() {
    try {
        return typeof window !== 'undefined' ? window.localStorage : null;
    } catch (_) {
        return null;
    }
}

function hashMarkup(markup) {
    const text = typeof markup === 'string' ? markup : '';
    let hash = 0;
    for (let i = 0; i < text.length; i += 1) {
        hash = ((hash << 5) - hash) + text.charCodeAt(i);
        hash |= 0;
    }
    return `${text.length}:${hash.toString(16)}`;
}

export function mutationPreviewStorageKey(conversationId, markup) {
    if (!conversationId || typeof markup !== 'string' || !markup.trim()) {
        return null;
    }
    return `${STORAGE_PREFIX}${conversationId}:${hashMarkup(markup)}`;
}

/**
 * @param {string|null|undefined} conversationId
 * @param {string|null|undefined} markup
 * @returns {{frozen: boolean, opStatuses: Record<string, string>}|null}
 */
export function readPersistedMutationPreview(conversationId, markup) {
    const key = mutationPreviewStorageKey(conversationId, markup);
    const storage = safeStorage();
    if (!key || !storage) {
        return null;
    }
    try {
        const raw = storage.getItem(key);
        if (!raw) {
            return null;
        }
        const parsed = JSON.parse(raw);
        if (!parsed || typeof parsed !== 'object') {
            return null;
        }
        const opStatuses = parsed.opStatuses && typeof parsed.opStatuses === 'object'
            ? parsed.opStatuses
            : null;
        return {
            frozen: Boolean(parsed.frozen),
            opStatuses,
        };
    } catch (_) {
        return null;
    }
}

/**
 * @param {string|null|undefined} conversationId
 * @param {string|null|undefined} markup
 * @param {{frozen?: boolean, opStatuses?: Record<string, string>|null}} detail
 */
export function writePersistedMutationPreview(conversationId, markup, detail = {}) {
    const key = mutationPreviewStorageKey(conversationId, markup);
    const storage = safeStorage();
    if (!key || !storage) {
        return;
    }
    try {
        storage.setItem(key, JSON.stringify({
            frozen: Boolean(detail.frozen),
            opStatuses: detail.opStatuses && typeof detail.opStatuses === 'object'
                ? detail.opStatuses
                : null,
        }));
    } catch (_) {
        // Quota / private mode — inference from the chart still covers Apply.
    }
}
